React = require 'react'
t = require('views/internal/recup-with-helpers')()

module.exports = class extends React.Component
  render: t.renderable ->
    { total, processed } = @props
    progress = if total > 0
        "#{ processed }/#{ total }"
      else
        ""

    t.div ->
      t.div '.spinner.loading'
      t.div '.dash-bulk-add-progress', ->
        t.text progress



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/progress-component/running-component.coffee